import type { EnergyTypes } from '@libs/interfaces/interfaces'

export const energyTypeColors: EnergyTypes = {
	current: {
		chargingPoint: '#46a06e',
		electricity: '#46a06e',
		heat: '#f07d00',
		solar: '#e1db93',
		water: '#69a0be',
		wind: '#e3ffe6',
	},
	historic: {
		chargingPoint: '#90c6a8',
		electricity: '#90c6a8',
		heat: '#f6b166',
		solar: '#f5f0b8',
		water: '#a5c6d8',
		wind: '#e6fae8',
	},
}
